import * as sonbp from "sonbp";
import * as ifbase from "../base";
import * as tool from '../tool'
import { drawCommon } from "./drawCommon"


/**
* ポスカ用ドラッガー
* @summary ドロップ配置を行います。
*/
export class poscaImageDragger extends sonbp.listener.imageDragger {

	private _ifdto: ifbase.ifDto;

	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super();

		this._ifdto = ifdto;
	}

	// -----------------------------------------------
	// Properties（内部変数）
	// -----------------------------------------------

	/**
	* 準備対象の画像ID
	*/
	protected _fileId: string = null;

	/**
	* 選択状態のアイテムID
	*/
	protected _selectItem: sonbp.object.baseItem = null;

	// -----------------------------------------------
	// Methods（外部アクセス用メソッド）
	// -----------------------------------------------

	/**
	 * アイテム選択
	 */
	public select(id: string): void {

		if (id == null) {
			this._selectItem = null;
			return;
		}

		let layer = ifbase.util.getLayer(this._ifdto, ifbase.constants.LTYPE_PHOTO).layer;
		var items = ifbase.util.getItems(layer.items, function (item: sonbp.object.baseItem): boolean {
			return item.id == id;
		});
		this._selectItem = items[0];
	}

	/**
	 * ドラッグ開始
	 * @param srcUrl ドラッグ時に使用する画像ソースを設定します。※使用ソースがない場合は空文字をセット
	 * @param dropNg ドロップ禁止とするエリアを設定します。
	 */
	public dragStart(srcUrl: string, file_key: string, file_id: string, img_size: { w: number, h: number }): void {

		this.releaseHandle();

		// ドラッグ準備
		this.dragPreparation(srcUrl, []);

		// クリップ候補の収集
		this._clipper = null;
		this._clippers = [];
		sonbp.util.obj.checkItem(this._v, (item, address) => {
			if (ifbase.util.chkIsPhotobox(item)) {
				let group = item as sonbp.object.groupItem;
				this._clippers.push({
					group: group,
					drawCmds: sonbp.util.c2d.setCommandsMatrix(group.clip_item._commands, item._apply_pmatrix)
				});
			}
			return false;
		}, this._v._dm.pageIdxs, null, true);

		// サーバ情報取得
		this._prepareUniqueId = sonbp.util.js.uuid();
		this._prepareData = null;

		let that = this;
		let dragUniqueId = this._prepareUniqueId;
		ifbase.util.getResouseKey(this._ifdto, file_key).then((d: ifbase.ImageResourceModel) => {

			that._prepareData = {
				uniqueId: d.UniqueId,
				resKey: d.FileKey,
				subType: d.Subtype,
				width: d.Width,
				height: d.Height,
				//
				orgSize: img_size,
				dragUniqueId: dragUniqueId
			} as any;
			that._fileId = file_id;

		}).catch(e => {

			that._prepareUniqueId = "";
			that.releaseHandle();
			that._ifdto.callbackError(e);
		});

	}

	// -----------------------
	// 描画機能 関数
	// -----------------------

	/**
	 * eidtCanvasへの描画
	 * @override
	 */
	public drawEditCanvas(co: sonbp.draw.editCanvasOperator): void {

		co.ctx.save();

		let items = this._clippers.map(d => d.group);
		drawCommon.drawCandidate(this._ifdto, co.ctx, items);

		co.ctx.restore();

		// 選択アイテムの表示
		if (this._selectItem != null) {
			// 画像枠なら外接矩形ではなく、クリップパスで描画する
			co.ctx.save();

			let item = this._selectItem;
			this._v._dm.pageTransform(item._apply_pageIdx, co.ctx);

			drawCommon.drawSelectedBox(this._ifdto, co.ctx, item);

			co.ctx.restore();
		}

		// ドロップ可能領域の表示
		super.drawEditCanvas(co);

	}

	// -----------------------------------------------
	// Methods（内部関数）
	// -----------------------------------------------

	/**
	 * 操作状態の初期化
	 * @summary 現在保持している操作状態を初期化します。
	 */
	protected releaseHandle(): void {
		super.releaseHandle();

		this._prepareUniqueId = "";
		this._fileId = null;
	}

	/**
	 * ドロップ処理
	 */
	protected drop(): void {

		if (!this._clipper || this._prepareUniqueId == "") {
			// 枠外にドロップ
			this.releaseHandle();
			sonbp.util.bp.notice(this._v, [this._cancelFunc], "NOTICE");
			return;
		}

		// 待ち合わせ
		this._inDropping = true;

		let that = this;
		sonbp.util.js.loopSleep(this._v._eff.dragIntervalCnt, this._v._eff.dragInterval, () => {

			if (!that._clipper || that._prepareUniqueId == "") {
				sonbp.util.bp.notice(that._v, [that._cancelFunc], "NOTICE");
				return false;
			}
			if (!that._isHandled) return false;	

			if (that._prepareData == null || this._prepareUniqueId != (that._prepareData as any).dragUniqueId) return true;

			try {

				// 画像配置
				let fileKey = that._prepareData.resKey;
				let imgSize = (that._prepareData as any).orgSize;
				let group = that._clipper.group;

				tool.photoMani.setPhotoImg(that._ifdto, that._clipper.group.id, fileKey, that._fileId, imgSize, false, function (resKey) {

					// 画像読込
					let img = that._ifdto.bpView._cm.getImg(resKey);
					if (img.status == 2) {
						that._ifdto.bpView._dm.reDraw();
					} else {
						img.getdata(0, false, false,
							function (size: number, wh?: number[]) {
								that._ifdto.bpView._dm.reDraw();
							},
							function (e: TypeError) {
								console.error(e);
							});
					}

					sonbp.util.bp.notice(that._v, [that._compFunc], "NOTICE", {
						id: group.id,
						file_key: fileKey,
						resource_key: resKey,
						//
						item_type: group.info.vendor_property.ffpsc.item_type,
						idx: group.info.vendor_property.ffpsc.idx,
						file_id: group.childs[0].info.vendor_property.ffpsc.file_id
					});

					that.releaseHandle();
				});

			} catch (e) {

				that.releaseHandle();

				that._ifdto.callbackError(e);
			}

			return false;

		}, "", () => {

				// 待ち合わせ失敗
				that.releaseHandle();
				sonbp.util.bp.errorNotice(that._v, "EXCEPTION");
		});

	}

}